// extracted by mini-css-extract-plugin
module.exports = {"progressFill":"ProgressPieChart_progressFill__8hITv","progressPieChart":"ProgressPieChart_progressPieChart__JvKho","progressBorder":"ProgressPieChart_progressBorder__hrWfN"};